// Lo elegido en los selectores de un sitio, en la URL: `?picks=hijos:ID` (varias
// separadas por coma). Claves de fuente e ids de registro no llevan «:» ni «,».

export type SitePicks = Record<string, string>;

const KEY_RE = /^[a-z][a-z0-9_]{0,59}$/;
const ID_RE = /^[A-Za-z0-9_-]{1,64}$/;

export function parsePicks(raw: unknown): SitePicks {
  if (typeof raw !== "string" || !raw) return {};
  const out: SitePicks = {};
  for (const part of raw.split(",").slice(0, 10)) {
    const at = part.indexOf(":");
    if (at <= 0) continue;
    const key = part.slice(0, at);
    const id = part.slice(at + 1);
    if (KEY_RE.test(key) && ID_RE.test(id)) out[key] = id;
  }
  return out;
}

export function serializePicks(picks: SitePicks): string | undefined {
  const parts = Object.entries(picks)
    .filter(([key, id]) => KEY_RE.test(key) && ID_RE.test(id))
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([key, id]) => `${key}:${id}`);
  return parts.length ? parts.join(",") : undefined;
}
